import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../logo.png';

const Sidebar = ({ menuItems, isOpen, setIsOpen, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleItemClick = (path) => {
    navigate(path);
    setIsOpen(false); // Auto-close sidebar on mobile after selection
  };

  return (
    <>
      {/* Mobile Backdrop overlay */}
      {isOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setIsOpen(false)}
        />
      )}

      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <img src={logo} alt="IPS Logo" className="sidebar-logo" />
          <h3>Cooperative Machinery Tracker v2.0</h3>
          <button className="sidebar-close-btn" onClick={() => setIsOpen(false)}>
            ✕
          </button>
        </div>

        <ul className="sidebar-menu">
          {menuItems.map((item) => (
            <li key={item.name}>
              <button
                className={`sidebar-item ${location.pathname === item.path ? 'active' : ''}`}
                onClick={() => handleItemClick(item.path)}
              >
                <span className="sidebar-icon">{item.icon}</span>
                <span>{item.name}</span>
              </button>
            </li>
          ))}
        </ul>

        <button
          className="sidebar-item sidebar-logout"
          onClick={() => {
            setIsOpen(false);
            onLogout();
          }}
        >
          <span className="sidebar-icon">🚪</span>
          <span>Sign Out</span>
        </button>
      </aside>
    </>
  );
};

export default Sidebar;
